import React from "react";
// import components
import { Heading } from "@chakra-ui/react";

const E404 = () => {
    return (
        <div className="fixed text-center top-2/4 start-2/4 translate-x-2/4 -translate-y-2/4">
            <Heading as="h2" size="4xl">
                404
            </Heading>
            <p>هذه الصفحة غير متوفرة</p>
        </div>
    );
};

export default E404;
